/** @format */
/**
 * Internal dependencies
 */
import actions from './actions';
import reducer from './reducer';
import resolvers from './resolvers';
import selectors from './selectors';
import controls from './controls';

export default {
	actions,
	reducer,
	resolvers,
	selectors,
	controls,
};
